export const GETDEALERS_SUCCESS = "GETDEALERS_SUCCESS";
export const GETDEALERS_ERROR = "GETDEALERS_ERROR";

export const CHANGEACTION_SUCCESS = "CHANGEACTION_SUCCESS";
export const CHANGEACTION_ERROR = "CHANGEACTION_ERROR";

export const APPROVAL_SUCCESS = "APPROVAL_SUCCESS";
export const APPROVAL_ERROR = "APPROVAL_ERROR";

